import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { LockOutlined } from '@ant-design/icons';
import { AiOutlineCheck } from 'react-icons/ai';

import { FINISHED } from './constants';

import useImage from '@shared/hooks/useImage';

import Utils from '@/Utils';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './MaterialCard.module.scss';

const MAX_TITLE_LENGTH = 45;

const MaterialCard = ({ topic, trackId, isLocked }) => {
  const cover = useImage(topic?.thumbFileUuid, 'planning', topic?.type?.id);

  const isFinished = topic.userPlanStatus === FINISHED;

  const renderStatus = useMemo(() => {
    if (isLocked) {
      return (
        <div className={classNames(css['MaterialCard-checkbox'], css['MaterialCard-checkbox-locked'])}>
          <LockOutlined />
        </div>
      );
    } else {
      return (
        <div className={classNames(css['MaterialCard-checkbox'], isFinished && css['MaterialCard-checkbox-active'])}>
          {isFinished && <AiOutlineCheck size={14} />}
        </div>
      );
    }
  }, [topic, isLocked, trackId]);

  return (
    <Link
      to={{
        pathname: `/collection-topics/${topic.id}`,
      }}
      state={{ fromTrackId: trackId }}
      className={css['MaterialCard']}
      data-qa='trackMaterialCard'
    >
      {renderStatus}
      <div className={css['MaterialCard-cover--block']}>
        <div className={css['MaterialCard-cover-container']}>
          <img className={css['MaterialCard-cover']} src={cover} alt='MaterialCover' />
          {/* {topic.type.id && <TypeBadge className={css['MaterialCard-type']} typeId={topic.type.id} />} */}
        </div>
        <div className={css['MaterialCard-cover--title']}>
          <p className={css['MaterialCard-label']}>{topic.typeLabel?.name}</p>
          <p className={css['MaterialCard-title']}>{Utils.renderWithTooltip(topic?.name, MAX_TITLE_LENGTH)}</p>
        </div>
      </div>
    </Link>
  );
};

MaterialCard.propTypes = {
  topic: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    thumbFileUuid: PropTypes.string,
    type: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      approved: PropTypes.bool,
      withEvents: PropTypes.bool,
    }),
    typeLabel: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      topicTypeId: PropTypes.number,
    }),
    position: PropTypes.number,
    userPlanStatus: PropTypes.string,
  }),
};

export default MaterialCard;
